import DashboardRoundedIcon from "@mui/icons-material/DashboardRounded";
import InsightsRoundedIcon from "@mui/icons-material/InsightsRounded";
import PeopleAltRoundedIcon from "@mui/icons-material/PeopleAltRounded";
import GroupRoundedIcon from "@mui/icons-material/GroupRounded";
import CasinoRoundedIcon from "@mui/icons-material/CasinoRounded";
import AccountBalanceWalletRoundedIcon from "@mui/icons-material/AccountBalanceWalletRounded";
import RedeemRoundedIcon from "@mui/icons-material/RedeemRounded";
import EmojiEventsRoundedIcon from "@mui/icons-material/EmojiEventsRounded";
import GppGoodRoundedIcon from "@mui/icons-material/GppGoodRounded";
import AutoAwesomeRoundedIcon from "@mui/icons-material/AutoAwesomeRounded";

// Grouped navigation. Every route below maps to a real screen ported from
// casinoCoinAdminUI (plus the new MUI Dashboard at "/").
export const navGroups = [
  {
    items: [{ label: "Dashboard", path: "/", icon: DashboardRoundedIcon }],
  },
  {
    title: "Monitor",
    icon: InsightsRoundedIcon,
    items: [
      { label: "Overview", path: "/" },
      { label: "Games", path: "/monitor/games" },
      { label: "Revenue & P/L", path: "/monitor/revenue" },
      { label: "Acquisition", path: "/monitor/acquisition" },
      { label: "UTM Attribution", path: "/monitor/utm-attribution" },
      { label: "Analytics", path: "/monitor/analytics" },
      { label: "Retention", path: "/monitor/retention" },
      { label: "PWA Stats", path: "/monitor/pwa" },
    ],
  },
  {
    title: "Audience",
    icon: PeopleAltRoundedIcon,
    items: [
      { label: "Players 360", path: "/audience/players" },
      { label: "Segments", path: "/audience/segments" },
    ],
  },
  {
    title: "Players",
    icon: GroupRoundedIcon,
    items: [
      { label: "Users", path: "/UserList" },
      { label: "Blocked Domains", path: "/block-domain" },
      { label: "Action List", path: "/ActionList" },
      { label: "Access List", path: "/AccessList" },
    ],
  },
  {
    title: "Casino",
    icon: CasinoRoundedIcon,
    items: [
      { label: "Providers", path: "/provider" },
      { label: "Menu", path: "/menu" },
      { label: "Category", path: "/category" },
      { label: "Feature Games", path: "/featureGames" },
      { label: "Games", path: "/games" },
      { label: "Coin Package", path: "/coinPackage" },
      { label: "Promo", path: "/promo" },
      { label: "Redemption Claims", path: "/redemptionClaims" },
      { label: "Refer & Daily Claim", path: "/config-list" },
      { label: "Wheel of Fortune", path: "/wheel-of-fortune" },
      { label: "Lottery", path: "/lottery" },
    ],
  },
  {
    title: "Finance",
    icon: AccountBalanceWalletRoundedIcon,
    items: [
      { label: "Transfer", path: "/Transfer" },
      { label: "Payments", path: "/Payments" },
      { label: "Withdrawals", path: "/withdrawals" },
      { label: "Exchange Rate", path: "/exchange-rate" },
    ],
  },
  {
    title: "Promotions",
    icon: RedeemRoundedIcon,
    items: [
      { label: "Loyalty", path: "/loyalty" },
      { label: "Banner", path: "/Banner" },
      { label: "Marketing Popup", path: "/MarketingPopup" },
      { label: "Popup Offers", path: "/popup-offers" },
      { label: "All Promotions", path: "/all-promotions" },
      { label: "Monthly Promotions", path: "/monthly-promotions" },
      { label: "Mail-In List", path: "/mailIn-list" },
      { label: "Offer List", path: "/offer-list" },
      { label: "Promo Codes", path: "/promo-campaigns" },
      { label: "Survey", path: "/survey" },
    ],
  },
  {
    title: "Engagement",
    icon: EmojiEventsRoundedIcon,
    items: [
      { label: "Happy Hours", path: "/happy-hours" },
      { label: "Happy Hour Earnings", path: "/happy-hour-earnings" },
      { label: "Streak Types", path: "/streak-types" },
      { label: "Tier Multifactor", path: "/tier-multifactor" },
    ],
  },
  {
    title: "Operate",
    icon: GppGoodRoundedIcon,
    items: [
      { label: "Risk & Fraud", path: "/operate/risk" },
      { label: "Marketing", path: "/operate/marketing" },
      { label: "Error Log", path: "/operate/error-log" },
    ],
  },
  {
    title: "Intelligence",
    icon: AutoAwesomeRoundedIcon,
    items: [
      { label: "AI Insights", path: "/intelligence/ai-insights" },
      { label: "Audit & Admin", path: "/intelligence/audit" },
    ],
  },
];
